import React from "react";
import { useLocation } from "react-router-dom";
import "../styles/Error.css"; // Assuming you have a CSS file for styling the error page

const Error = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const errorMessage =
    searchParams.get("message") || "An unexpected error occurred.";

  return (
    <div className="error-container">
      <h1 className="error-heading">Oops! Something went wrong.</h1>
      <p className="error-description">
        We encountered an error while processing your request. Please try again
        later.
      </p>
      <div className="error-box">
        <strong>Error:</strong> {errorMessage}
      </div>
    </div>
  );
};

export default Error;
